import { Form, Input, InputNumber, Select } from 'antd';
import React, { useEffect, useRef, useState } from 'react'
import WebEditUniversal, { WEUExtendPropsType } from '../../system/WebEditUniversalNewEx';
import AntDraggableModal from '../../../utils/extend/AntDraggableModal';
import getList from '../../universal/getList';
import fetchApi from '../../../utils/api/fetchApi';
import systemConfig from '../../../config/systematic';

//布局
const layout = {
  labelCol: { span: 8 },
  wrapperCol: { span: 16 },
};
export default function WarehouseInventoryEdit(props: any) {
  /** api服务id */
  const apiId = 'warehouseInventory';
  const [form] = Form.useForm(); //form 
  const { data } = props;
  let wmService: any = systemConfig.wmService;
  const ref = useRef<any>(undefined);
  /** 后端数据Service */
  let Service: any = "";
  const [productData, setProductData] = useState<any>();
  const handleOk = (e: any) => {
    ref.current.handleOk();
  };
  const handleCancel = (e: any) => {
    ref.current.handleCancel();
  };
  let extendProps: WEUExtendPropsType = {
    ...props,
    form,
    apiId
  };
  useEffect(() => {
    if (data.type === "EDIT") {
      ref.current.row.then(async (res: any) => {
        if (res.success === true) {
          fetchApi.GET(wmService, {
            apiId: "product",
            apiExtend: "showList",
            apiData: {
              productId: res.data.productId,
              mountDataOptions: {
                userMount: {
                  isDept: true,
                  isUserAreas: true
                }
              }
            }
          }).then(ress => {
            setProductData(ress.data)
          })

        }
      })
    }
  }, [])
  return (
    <>
      <WebEditUniversal ref={ref} props={extendProps} />

      <AntDraggableModal
        title={(data.type === 'NEW' ? '新增' : '编辑') + '仓库库存'}
        open={true}
        okText='确定'
        cancelText='取消'
        onOk={handleOk}
        onCancel={handleCancel}
        closable={false}
        maskClosable={false}
      >
        <Form
          {...layout}
          form={form}
          name="Edit"
          onFinish={handleOk}

        >
          <Form.Item
            label="id"
            name="id">
            <Input disabled={true} />
          </Form.Item>
          <Form.Item
            label="产品"
            name="productId"
            rules={[{ required: true, message: '产品!' }]}>
            <Select
              onSearch={(e) => getList.searchEx('product', setProductData, e, productData, {
                andWhereObj: {
                  mountDataOptions: {
                    userMount: {
                      isDept: true,
                      isUserAreas: true
                    }
                  }
                },
              })}
              // fieldNames={{value:"value"}}
              options={getList.generalSelcetOption(productData,"productName","id",aa) }
              showSearch
              placeholder="产品"
              optionFilterProp="children"
              filterOption={(input, option: any) => { return true }}>
             
            </Select>
          </Form.Item>
          <Form.Item
            label="期初数"
            name="openingQuantity">
            <InputNumber min={0.1} />
          </Form.Item>

          <Form.Item
            label="期初金额"
            name="openingPrice">
            <InputNumber min={0.1}/>
          </Form.Item>
        </Form>
      </AntDraggableModal>
    </>
  )
}
const aa=(item:any)=>{
  // console.log(item);
  return `${item.productName} ${item.productUnit.productUnitName}`
  
}
